import moment from "moment";
import { Timeslot } from "types/timeslot";
export const getDelay = (previousDate: Date | string, newDate: Date | string): number => {
  const previousTimeslotDay = moment(previousDate).startOf("day");
  const newTimeslotDay = moment(newDate).startOf("day");

  const delay = moment(newTimeslotDay).diff(previousTimeslotDay, "days");
  return delay;
};

export const getClosestTimeslot = (timeslots: Timeslot[]): Timeslot | null => {
  if (!timeslots?.length) return null;
  return timeslots.reduce((prev, current) => (prev.beginning < current.beginning ? prev : current));
};

export function sortByDate<T>(items: T[], key: keyof T, order: "desc" | "asc" = "asc"): T[] {
  if (order == "desc") {
    return items.sort((item1, item2) => {
      return -moment(item1[key]).diff(moment(item2[key]));
    });
  }
  return items.sort((item1, item2) => {
    return -moment(item2[key]).diff(moment(item1[key]));
  });
}
